export default __webpack_public_path__ + "static/media/CustomNe.a02c9856.jpeg";